












import Vue from 'vue'
// @ts-ignore
// dayNames: ['月', '火', '水', '木', '金', '土', '日']
import FlatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import dayjs from 'dayjs'

export default Vue.extend({
  components: {
    FlatPickr,
  },
  props: {
    values: {
      type: Array as () => string[],
      default: [],
    },
  },
  computed: {
    config(): object {
      return {
        mode: 'multiple',
        inline: true,
        locale: Japanese,
        nextArrow: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M10.413 5L9 6.414l5.657 5.656L9 17.728l1.414 1.414 7.071-7.072-1.414-1.414L10.415 5z" fill-rule="evenodd"/></svg>`,
        prevArrow: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M14.07 5l-5.657 5.656L7 12.07l7.071 7.072 1.414-1.414-5.657-5.658 5.657-5.656L14.072 5z" fill-rule="evenodd"/></svg>`,
        dateFormat: 'Y-m-d',
        minDate: dayjs().format('YYYY-MM-DD'),
        maxDate: dayjs().add(2, 'week').format('YYYY-MM-DD'),
      }
    },
  },
  methods: {
    disableMonthSelect() {
      // 月選択を無効にする
      //@ts-ignore
      document.querySelector('.flatpickr-monthDropdown-months').disabled = true
    },
    onChange(dates: string[]) {
      this.$emit('onChange', dates)
    },
  },
})
